import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery";
import {
  ADD_DIETARY_PREFRERENCES,
  GET_DIETARY_PREFRERENCES,
  DELETE_DIETARY_PREFRERENCES,
  DETAILS_DIETARY_PREFRERENCES,
  UPDATE_DIETARY_PREFRERENCES,
} from "../../config/constants";

const dietaryPreferencesService = createApi({
  reducerPath: "dietaryPreferencesService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }),
  tagTypes: ["Dietary"],
  endpoints: (builder) => ({
    getDietary: builder.query({
      query: (body) => ({
        url: GET_DIETARY_PREFRERENCES,
        method: "POST",
        data: body,
      }),
      providesTags: ["DietaryPreferences"],
    }),
    updateDietary: builder.mutation({
      query: ({ updatedData, id }) => ({
        url: `${UPDATE_DIETARY_PREFRERENCES}/${id}`,
        method: "PUT",
        data: updatedData,
      }),
      invalidatesTags: ["DietaryPreferences"],
    }),
    addDietary: builder.mutation({
      query: (newData) => ({
        url: ADD_DIETARY_PREFRERENCES,
        method: "POST",
        data: newData,
      }),
      invalidatesTags: ["DietaryPreferences"],
    }),
    deleteDietary: builder.mutation({
      query: (id) => ({
        url: `${DELETE_DIETARY_PREFRERENCES}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["DietaryPreferences"],
    }),
    detailDietary: builder.query({
      query: (id) => ({
        url: `${DETAILS_DIETARY_PREFRERENCES}/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetDietaryQuery,
  useUpdateDietaryMutation,
  useAddDietaryMutation,
  useDeleteDietaryMutation,
  useDetailDietaryQuery,
} = dietaryPreferencesService;

export default dietaryPreferencesService;
